import { HttpClient, HttpParams, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import * as Models from '../../models/models-index';

@Injectable()
export class DigitalAdvertisingScorecardService {

	constructor(private http: HttpClient) { }

	getDigitalAdvertisingScorecardMetrics(reportRequest: any): Promise<Models.DigitalAdvertisingScorecardMetricResponseModel> {
		return new Promise<Models.DigitalAdvertisingScorecardMetricResponseModel>((resolve, reject) => {
			this.http.post(environment.baseApiUri + '/report', JSON.stringify(reportRequest), { headers: { 'Content-Type': 'application/json' } })
				.toPromise()
				.then((response: Models.DigitalAdvertisingScorecardMetricResponseModel) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
}
